// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/gift_shop/gift_shop.proto" (package "mlmbox.client.gift_shop", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { GiftShop } from "./gift_shop.ts";
import type { ReviewRequest } from "./gift_shop.ts";
import type { WithdrawalRequest } from "./gift_shop.ts";
import type { CardUpdateInfoRequest } from "./gift_shop.ts";
import type { CreateRequest } from "./gift_shop.ts";
import type { GiftShop_Info } from "../../types/gift_shop.ts";
import type { GiftShop_Card_Id } from "../../types/gift_shop.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GiftShop_State } from "../../types/gift_shop.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.gift_shop.GiftShop
 */
export interface IGiftShopClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.GiftShop.State);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, GiftShop_State>;
    /**
     * @generated from protobuf rpc: CardGet(mlmbox.types.GiftShop.Card.Id) returns (mlmbox.types.GiftShop.Info);
     */
    cardGet(input: GiftShop_Card_Id, options?: RpcOptions): UnaryCall<GiftShop_Card_Id, GiftShop_Info>;
    /**
     * @generated from protobuf rpc: CardCreate(mlmbox.client.gift_shop.CreateRequest) returns (mlmbox.types.GiftShop.Info);
     */
    cardCreate(input: CreateRequest, options?: RpcOptions): UnaryCall<CreateRequest, GiftShop_Info>;
    /**
     * @generated from protobuf rpc: CardUpdate(mlmbox.client.gift_shop.CardUpdateInfoRequest) returns (mlmbox.types.GiftShop.Info);
     */
    cardUpdate(input: CardUpdateInfoRequest, options?: RpcOptions): UnaryCall<CardUpdateInfoRequest, GiftShop_Info>;
    /**
     * @generated from protobuf rpc: CardRemove(mlmbox.types.GiftShop.Card.Id) returns (google.protobuf.Empty);
     */
    cardRemove(input: GiftShop_Card_Id, options?: RpcOptions): UnaryCall<GiftShop_Card_Id, Empty>;
    /**
     * @generated from protobuf rpc: CardBuy(mlmbox.types.GiftShop.Card.Id) returns (mlmbox.types.GiftShop.Info);
     */
    cardBuy(input: GiftShop_Card_Id, options?: RpcOptions): UnaryCall<GiftShop_Card_Id, GiftShop_Info>;
    /**
     * @generated from protobuf rpc: Withdrawal(mlmbox.client.gift_shop.WithdrawalRequest) returns (mlmbox.types.GiftShop.Info);
     */
    withdrawal(input: WithdrawalRequest, options?: RpcOptions): UnaryCall<WithdrawalRequest, GiftShop_Info>;
    /**
     * @generated from protobuf rpc: Review(mlmbox.client.gift_shop.ReviewRequest) returns (mlmbox.types.GiftShop.Info);
     */
    review(input: ReviewRequest, options?: RpcOptions): UnaryCall<ReviewRequest, GiftShop_Info>;
}
/**
 * @generated from protobuf service mlmbox.client.gift_shop.GiftShop
 */
export class GiftShopClient implements IGiftShopClient, ServiceInfo {
    typeName = GiftShop.typeName;
    methods = GiftShop.methods;
    options = GiftShop.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.GiftShop.State);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, GiftShop_State> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, GiftShop_State>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CardGet(mlmbox.types.GiftShop.Card.Id) returns (mlmbox.types.GiftShop.Info);
     */
    cardGet(input: GiftShop_Card_Id, options?: RpcOptions): UnaryCall<GiftShop_Card_Id, GiftShop_Info> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GiftShop_Card_Id, GiftShop_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CardCreate(mlmbox.client.gift_shop.CreateRequest) returns (mlmbox.types.GiftShop.Info);
     */
    cardCreate(input: CreateRequest, options?: RpcOptions): UnaryCall<CreateRequest, GiftShop_Info> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRequest, GiftShop_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CardUpdate(mlmbox.client.gift_shop.CardUpdateInfoRequest) returns (mlmbox.types.GiftShop.Info);
     */
    cardUpdate(input: CardUpdateInfoRequest, options?: RpcOptions): UnaryCall<CardUpdateInfoRequest, GiftShop_Info> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CardUpdateInfoRequest, GiftShop_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CardRemove(mlmbox.types.GiftShop.Card.Id) returns (google.protobuf.Empty);
     */
    cardRemove(input: GiftShop_Card_Id, options?: RpcOptions): UnaryCall<GiftShop_Card_Id, Empty> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GiftShop_Card_Id, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CardBuy(mlmbox.types.GiftShop.Card.Id) returns (mlmbox.types.GiftShop.Info);
     */
    cardBuy(input: GiftShop_Card_Id, options?: RpcOptions): UnaryCall<GiftShop_Card_Id, GiftShop_Info> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GiftShop_Card_Id, GiftShop_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Withdrawal(mlmbox.client.gift_shop.WithdrawalRequest) returns (mlmbox.types.GiftShop.Info);
     */
    withdrawal(input: WithdrawalRequest, options?: RpcOptions): UnaryCall<WithdrawalRequest, GiftShop_Info> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<WithdrawalRequest, GiftShop_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Review(mlmbox.client.gift_shop.ReviewRequest) returns (mlmbox.types.GiftShop.Info);
     */
    review(input: ReviewRequest, options?: RpcOptions): UnaryCall<ReviewRequest, GiftShop_Info> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReviewRequest, GiftShop_Info>("unary", this._transport, method, opt, input);
    }
}
